export default "__VITE_ASSET__CyS8svyG__"